import { decodeString } from "../../utils";

export const normalizeHtmlParagraphs = message => {
	if (!message || (message.startsWith("<p>") && message.endsWith("</p>"))) {
		return message;
	}

	const messageWithParagraphs = message
		.replace(/<br\s*\/?>/gi, "</p><p>")
		.replace(/\n/g, "</p><p>");

	return `<p>${messageWithParagraphs}</p>`;
};

export const normalizeNoteMessage = message => {
	const decodedMessage = decodeString(message);

	return normalizeHtmlParagraphs(decodedMessage);
};